module.exports = __webpack_public_path__ + "static/media/icn_link.9eaaa48c.svg";